module.exports = __webpack_public_path__ + "static/media/movTransit.7270d1ff.svg";